import React, { FC, useMemo } from 'react';
import { INITIAL_POOL_FEE } from '@cryptoalgebra/kim-sdk';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { useDerivedManualMintInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedManualMintInfo';
import { AddLiquidityRangeSelector } from '../AddLiquidityRangeSelector/AddLiquidityRangeSelector';
import AddLiquidityInputAmounts from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/AddLiquidityInputAmounts/AddLiquidityInputAmounts';
import AddLiquidityButton from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/AddLiquidityButton';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const AddLiquidityManual: FC<Props> = ({ mintInfo: commonMintInfo }) => {
  const {
    currencyA,
    currencyB,
    startPriceTypedValue,
    actions: { setStep, typeStartPriceInput }
  } = useLiquidityWizardState();
  const { poolAddress } = commonMintInfo;

  const mintInfo = useDerivedManualMintInfo(
    currencyA,
    currencyB,
    poolAddress,
    INITIAL_POOL_FEE,
    currencyA
  );

  const price = useMemo(() => {
    if (!mintInfo.price) return;

    return mintInfo.invertPrice ? mintInfo.price.invert() : mintInfo.price;
  }, [mintInfo]);

  return (
    <>
      <AddLiquidityRangeSelector
        onStartPriceInput={typeStartPriceInput}
        mintInfo={mintInfo}
        startPriceTypedValue={startPriceTypedValue}
        price={price}
        currencyB={currencyB}
        currencyA={currencyA}
      />
      <AddLiquidityInputAmounts
        price={price}
        mintInfo={mintInfo}
        currencyA={currencyA}
        currencyB={currencyB}
      />
      <AddLiquidityButton
        baseCurrency={currencyA}
        quoteCurrency={currencyB}
        mintInfo={mintInfo}
        poolAddress={poolAddress}
        onComplete={() => setStep(2)}
      />
    </>
  );
};
